import { PropsWithChildren } from "react";

export function Hours({ children }: PropsWithChildren) {
  return (
    <span className="text-[#78829D] border-[#DBDFE9] border-[1px] bg-[#F9F9F9] rounded self-center py-[9px] px-2.5">
      {children}
    </span>
  );
}
